import { IMenuPages } from '@llws/lift-entity-interfaces';
import { Equal, IQueryCommandOptions, Null } from '@llws/dynamic-router-utils';
import { subsetObject } from '@/shared';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { IProcessorPayload } from '@/shared/interfaces/processor-payload';
import { DataModifyProcessor } from '@/shared/classes/data-modify-processor';
import config from '@/config';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/menu_pages';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'page',
      alias: 'page',
    },
  ],
  where: [
    Equal('page.status', 'enabled'),
    // Equal('showInMenu', '1'),
    Null('page.parentId'),
  ],
  orderBy: [
    {
      field: 'orderBy',
      direction: 'asc',
    },
  ],
  limit: 1000,
};

const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'page',
      alias: 'page',
    },
  ],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IMenuPages>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'maintenance/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,

    saveAllMenuPagesInKey: async (ctx: IAction<IStateStrict<IMenuPages>>, payload: IProcessorPayload<IMenuPages>) => {
      const processor = new DataModifyProcessor(`${config.adminGateway}/website-api/menu_pages`);
      processor.deleteItems = payload.toRemove;
      processor.postItems = payload.toInsert.map((v) => subsetObject(v, ['page']));
      processor.putItems = payload.toUpdate.map((v) => subsetObject(v, ['page']));
      await processor.execute();
    },
  },
};
